import {
	API_SEARCH_COMPANY,
	API_SEARCH_COMPANY_SUCCESS,
	API_SEARCH_COMPANY_FAIL
} from '../actions/company';
import { createReducer } from '@reduxjs/toolkit';
import { ErrorAction, errorHandler } from 'utils/error';
import { getVersion } from "services/company";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

const adaptCompanyResponse = (company, currentClient) => {
	try {
		if (!company || currentClient !== V2_CLIENT) {
			return company;
		}

		const adapted = { ...company };

		const fieldMap = {
			postalCode: 'postal_code',
			silId: 'sil_id',
			lastModificationVersionGeslab: 'last_modification_version_geslab',
			updatedDate: 'updated_date',
			disabledDate: 'disabled_date',
			createdDate: 'created_date',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		return adapted;
	} catch (error) {
		console.error('Error in adaptCompanyResponse:', error);
		return company;
	}
};

export const adaptCompanyPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				const adaptedData = data.map((item) => adaptCompanyResponse(item, currentClient));
				return {
					...payload,
					data: adaptedData,
				};
			} else if (typeof data === 'object' && data !== null) {
				const adaptedData = adaptCompanyResponse(data, currentClient);
				return {
					...payload,
					data: adaptedData,
				};
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptCompanyPayloadResponse:', error);
		return action.payload || {};
	}
};

const initialState = {
	loading: false,
	list: [],
	exists: null,
	company: null
};

const companies = createReducer(initialState, {
	/** SEARCH **/
	[API_SEARCH_COMPANY]: (state, action) => {
		state.loading = true;
	},
	[API_SEARCH_COMPANY_FAIL]: (state, action) => {
		errorHandler("Société", ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_SEARCH_COMPANY_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptCompanyPayloadResponse(action, API_SEARCH_COMPANY);
		state.list = adaptedPayload.data || [];
	}
});

export default companies;
